window.Ziggy = require('../ziggy.js').Ziggy;
window.route = require('../../../../node_modules/ziggy/dist/js/route');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/ziggy.js